let view_timer = null
/**
 * 通过js控制viewPort视区自适应缩放的方法
 * 仅对移动端有效-对pc端无效【待优化】
 * pageWidth:页面设计图的宽度
 **/
function viewPort(userAgent, isSkip, pageWidth) {
  let oView = document.getElementById('viewport')
  let screen_w = parseInt(window.screen.width)
  let screen_h = parseInt(window.screen.height)
  // window.screen.width:整个屏幕的宽度
  // let screen_w = parseInt(window.innerWidth)
  // let screen_h = parseInt(window.innerHeight)
  if (oView) {
    document.head.removeChild(oView)
  }

  if (!pageWidth) {
    // 区分手机和pad
    pageWidth = screen_w <= 767 ? 375 : 1440
  }

  /** 屏幕与设计图的比例 */
  let scale
  let create_meta
  create_meta = document.createElement('meta')
  create_meta.name = 'viewport'
  create_meta.id = 'viewport'
  let screen_size
  // 竖屏为0|横屏-90,90// 判断移动设备横屏竖屏
  // let isLandscape = (window.orientation === '-90' || window.orientation === '90')
  let isLandscape = window.matchMedia('(orientation: landscape)').matches
  e = window.matchMedia('(orientation: landscape)').matches
  // ios且横屏-取高度，其他取宽度，ios短边为宽，长边为高；安卓横向为宽
  screen_size = (judgeIos(userAgent) && isLandscape) ? screen_h : screen_w
  // 屏幕与设计图的比例
  scale = screen_size / pageWidth

  // 指定页面-不进行缩放处理页面
  if (isSkip || judgePathSkip()) {
    create_meta.content = 'width=device-width, initial-scale=1.0, user-scalable=no'
  } else if (judgeIos(userAgent)) {
    create_meta.content = 'width=' + pageWidth + ', initial-scale = ' + scale + ', minimum-scale = ' + scale + ', maximum-scale = ' + scale + ', user-scalable=no'
  } else {
    let version = parseFloat(RegExp.$1)
    if (version > 2.3) {
      create_meta.content = 'width=' + pageWidth + ', initial-scale = ' + scale + ', minimum-scale = ' + scale + ', maximum-scale = ' + scale + ', user-scalable=no'
    } else {
      create_meta.content = 'width=' + pageWidth
    }
  }
  document.head.appendChild(create_meta)

}

viewPort(navigator.userAgent)

window.onresize = function () {
  clearTimeout(view_timer)
  view_timer = setTimeout(function () {
    viewPort(navigator.userAgent)
  }, 500)
}

window.addEventListener('enterRouter', function (event) {
  let { isSkip } = event.data
  viewPort(navigator.userAgent, isSkip)
})

/** 判断是否安卓 */
function judgeAndroid(userAgent) {
  var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1; //g
  return isAndroid
}

/**  判断是否ios终端 */
function judgeIos(userAgent) {
  var isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  return isIOS
}

function judgePathSkip() {
  let { pathname, hash } = window.location
  let path = hash ?? pathname
  return ['/privacy-policy', '#/privacy-policy', '/terms-of-use', '#/terms-of-use'].includes(path)
}
